import {ProductFormData} from "./types";

enum Method {
    POST = "POST",
    GET = "GET",
    PUT = "PUT",
    DELETE = "DELETE"
}


async function strapiFetch(
    endpoint: string,
    body: any = undefined,
    method: Method = Method.GET,
    auth: boolean = true,
    contentType?: string
): Promise<any> {
    const token = localStorage.getItem('authToken');
    const headers: Record<string, string> = {};

    if (auth && token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    if (!(body instanceof FormData) && contentType) {
        headers['Content-Type'] = contentType;
    }

    const res = await fetch(
        `${process.env.REACT_APP_STRAPI_API_URL}/${endpoint}`,
        {
            headers,
            method,
            body,
        }
    );

    if (!res.ok) {
        throw new Error(`Strapi API Error: ${res.status} ${res.statusText}`);
    }
    if (res.status === 204) {
        return;
    }
    return res.json();
}


export async function login(identifier: string, password: string) {
    return await strapiFetch(`auth/local`, JSON.stringify({
        identifier,
        password
    }), Method.POST, false, 'application/json');
}

export async function getProductByDocumentId(documentId: string) {
    return await strapiFetch(`products/${documentId}?populate[0]=images&populate[1]=materials&populate[2]=dimensions&populate[3]=configuration&populate[4]=configuration.option_categories&populate[5]=configuration.option_categories.options&populate[6]=configuration.option_categories.defaultOption&populate[7]=configuration.price_configurations&populate[8]=configuration.price_configurations.selectedOptions&populate[9]=category&populate[10]=subcategory&populate[11]=image&populate[12]=hoverImage&populate[13]=customerPhotos`);
}

export async function deleteProductByDocumentId(documentId: string) {
    return await strapiFetch(`products/${documentId}`, null, Method.DELETE);
}

function buildProductsQuery({
                                productNumber,
                                name,
                                subcategoryDocId,
                                page = 1,
                                pageSize = 9,
                            }: {
    productNumber?: string;
    name?: string;
    subcategoryDocId?: string;
    page?: number;
    pageSize?: number;
}) {
    const offset = (page - 1) * pageSize;
    let query = `products?sort[0]=rating:desc&populate=*`;
    const filters: string[] = [];

    if (productNumber) {
        filters.push(`filters[productNumber][$eq]=${productNumber}`);
    }
    if (name) {
        filters.push(`filters[name][$containsi]=${name}`);
    }
    if (subcategoryDocId) {
        filters.push(`filters[subcategory][documentId][$eq]=${subcategoryDocId}`);
    }
    if (filters.length) {
        query += `&${filters.join('&')}`;
    }
    query += `&pagination[start]=${offset}&pagination[limit]=${pageSize}`;

    return query;
}

export async function getProducts({
                                      productNumber,
                                      name,
                                      subcategoryDocId,
                                      page = 1,
                                      pageSize = 9,
                                  }: {
    productNumber?: string;
    name?: string;
    subcategoryDocId?: string;
    page?: number;
    pageSize?: number;
}) {
    const query = buildProductsQuery({
        productNumber,
        name,
        subcategoryDocId,
        page,
        pageSize,
    });

    return await strapiFetch(query);
}

export async function getSubcategoriesList() {
    return await strapiFetch('subcategories');
}

export async function uploadImages(images: FormData) {
    return await strapiFetch(`upload`, images, Method.POST, true, undefined);
}

export async function getCategories(startingWith: string) {
    return await strapiFetch(`categories?filters[localizedName][$startsWith]=${startingWith}`);
}

export async function getSubcategories(startingWith: string, categoryId: number) {
    return await strapiFetch(`subcategories?filters[$and][0][localizedName][$startsWith]=${startingWith}&filters[$and][1][category][id][$eq]=${categoryId}`);
}

export async function createProduct(productFormData: ProductFormData) {
    return await strapiFetch(`product/custom`, JSON.stringify(productFormData), Method.POST, true, 'application/json');
}

export async function updateProduct(documentId: string, productFormData: ProductFormData) {
    return await strapiFetch(`product/custom${documentId}`, JSON.stringify(productFormData), Method.PUT, true, 'application/json');
}
